import "./topMenu.css"
import gPlayS from "../../../assets/images/gplay_arrow_s.png"
import aStoreS from "../../../assets/images/astore_apple_s.png"
import React, {useEffect, useState} from "react";
import { useLocation } from "react-router-dom";


const TopMenu =(props)=> {

//   useEffect(()=> {
//     //Initializing Smart Script arguments
//     var oneLinkURL = "https://tmy-hn.onelink.me/r0rh";
//     var mediaSource = {keys:["utm_source"],defaultValue:"organico"};
//     var campaign = {keys:["utm_campaign"],defaultValue:"(not%20set)"};
//     var ad = {keys:["utm_content"],defaultValue:"(not%20set)"};
//     var googleClickIdKey = "af_sub1";
//     var custom_ss_ui = {paramKey:"af_ss_ui",defaultValue:"true"};

//     //Call the function after embedding the code through a global parameter on the window object called window.AF_SMART_SCRIPT.
//     //Onelink URL is generated.
//     var result = window.AF_SMART_SCRIPT.generateOneLinkURL({
//         oneLinkURL: oneLinkURL,
//         afParameters: {
//             mediaSource: mediaSource,
//             campaign: campaign,
//             ad: ad,
//             googleClickIdKey: googleClickIdKey,
//             afCustom: [
//                 custom_ss_ui
//             ]
//         }
//     });
//     console.log('result', result);

//     if (result) {
//       let result_url = result.clickURL;            
//       // Put the generated OneLink URL behind CTA buttons
//       document.getElementById('andrd_link').setAttribute('href', result_url);
//       document.getElementById('ios_link').setAttribute('href', result_url);
//       // Optionally - Create QR code from the generated OneLink URL
//       window.AF_SMART_SCRIPT.displayQrCode("my_qr_code_div_id");
//       //The size of the QR code is defined in the CSS file under #my_qr_code_div_id
//       // #my_qr_code_div_id canvas { 
//       //  height: 200px;
//       //  width: 200px;
//       //}
//       // Optionally - fire an impression.
//       // The impression will fire to https://impressions.onelink.me//.... 
//       window.AF_SMART_SCRIPT.fireImpressionsLink();
// }
//   }, [])


  const tmpQuery = `
  {
    homePageCollection(where: {slug: "home-&slug&"}) {
        items{
          downloadAppButtonsHome {
            title
            downloadButtons
          }
          helpLabel
          helpUrl
        }
    }
  }
  `;
  const location = useLocation();
  const [dataButtons, setDataButtons] = React.useState(false);
  const [labelText, setLabelText] = React.useState("¡Descarga ya!");
  const [helpData, setHelpData] =React.useState({url: "#", label: "CENTRO DE AYUDA"})
  const [urlData, setUrlData ] = React.useState([]);

  useEffect(()=> {
    
    const url = String(location.pathname).split("/");
    
    const URLArray = String(window.location.href).split('?');
    
    let URLString = String(URLArray[0]).replace('http://', '').replace('https://', '');
    

    setUrlData(String(URLString));
    let slug = url[1];

    if (slug === 'pa') {
      slug = 'pa-old'
    }
    const query = tmpQuery.replace('&slug&', slug);
    // console.log('query top Header', query );
    

    window
        .fetch(`https://graphql.contentful.com/content/v1/spaces/5btn2y9mgkqy/`, {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            // Authenticate the request
            Authorization: "Bearer b3AQUpg-vBOOEAh9q_GsxA5r5Iq170qfW8BnsdAjObE",
            },
            // send the GraphQL query
            body: JSON.stringify({ query }),
        })
        .then((response) => response.json())
        .then(({ data, errors }) => {
            if (errors) {
              console.error("erros", errors);
            } 
            // console.log ('data top header', data)
            
            setDataButtons(data.homePageCollection.items[0].downloadAppButtonsHome.downloadButtons);
            // console.log(data.homePageCollection.items[0].downloadAppButtonsHome.downloadButtons)
            setLabelText(data.homePageCollection.items[0].downloadAppButtonsHome.title)
            setHelpData({url: data.homePageCollection.items[0].helpUrl, label:data.homePageCollection.items[0].helpLabel})
            
            // setHelpData(data.homePageCollection.items[0])
            // props.urlAppButtos = data.downloadAppButtonsHome?.downloadButtons;
        });

  }, [])


  

  const setLink =() => {
    //Initializing Smart Script arguments
     
      // console.log('url buttons', props.urlAppButtos);

    //  if (dataButtons.items[0].cta === "https://tmy-hn.onelink.me/r0rh") {

        // var oneLinkURL = "https://tmy-hn.onelink.me/r0rh";
        // console.log("cta ", dataButtons.items[0].cta)
        var oneLinkURL = dataButtons.items[0].cta;
        var mediaSource = {keys:["utm_source"],defaultValue:"Discovery-Web"};
        // var campaign = {keys:["utm_campaign"],defaultValue:"(not%20set)"+"_Discovery-Web", overrideValues:{"campaign": "nwcampain"}}; //default actual URL 
        // var campaign = {keys:["utm_campaign"],defaultValue:urlData+"_Discovery-Web"}; //default actual URL 
        var campaign = {keys:["utm_campaign"],defaultValue:"Discovery-Web"}; //default actual URL 
        var ad = {keys:["utm_content"],defaultValue:"(not%20set)"};
        var adSet = {keys:["utm_term"], defaultValue:"Discovery-Web"} 
        var channel = {keys:['utm_channel'], defaultValue:urlData} // check with client about parameterg
        var googleClickIdKey = "af_sub1";
        var custom_ss_ui = {paramKey:"af_ss_ui",defaultValue:"true"};


        var urlParams = new URLSearchParams(window.location.search);
        var utmCampaignValue = urlParams.get("utm_campaign");

        
        if (utmCampaignValue) {
          campaign.overrideValues =  {[utmCampaignValue.toString()]: utmCampaignValue.toString() + '_Discovery-Web'}//utmCampaignValue + "_Discovery-Web";
        }

      
        //Call the function after embedding the code through a global parameter on the window object called window.AF_SMART_SCRIPT.
        //Onelink URL is generated.
        
        var result = window.AF_SMART_SCRIPT.generateOneLinkURL({
            oneLinkURL: oneLinkURL,
            afParameters: {
                mediaSource: mediaSource,
                campaign: campaign,
                ad: ad,
                channel: channel,
                adSet: adSet,
                googleClickIdKey: googleClickIdKey,
                afCustom: [
                    custom_ss_ui
                ]
            }
        });

        console.log('result smartLink',  result)

        if (result) {
          window.open(result.clickURL)
        }

      // } else {
      //   if (os === 'ios') {
      //     console.log('here',  dataButtons.items[0].cta)
      //     window.open(dataButtons.items[0].cta)
      //   }
      //   else {
      //     console.log('here',  dataButtons.items[1].cta)
      //     window.open(dataButtons.items[1].cta);
      //   }
      // }
    

    

  }

    return(
        <div className="top-menu d-flex justify-content-end">
          <div className="col-6 col-md-2 account-btn  d-flex justify-content-center align-items-center">
              {/* <a className=""  href={props.urlAccount} target="_blank" rel="noreferrer">
                Tu cuenta Tigo Money
              </a> */}
              <a className=""  href={helpData.url} target="_blank" rel="noreferrer">
                {helpData.label}
              </a>
          </div>
          {/*<div className="col-6 col-md-2 download-btn-top  d-flex justify-content-center align-items-center">
               <div  > 
                <div className="download-now">¡Descarga ya!</div>
                <div onClick={()=>setLink()}  className="download-now ">{labelText}</div>
               <div className="col-6  s-btn d-flex justify-content-center align-items-center">
                    <a onClick={()=>setLink("android")}  target="_blank" rel="noreferrer">
                        <img className="img-btn-s " src={gPlayS}  alt="gplay"/>
                    </a>
                </div>
                <div  className="col-6  s-btn  d-flex justify-content-center align-items-center">
                  <a onClick={()=>setLink("ios")}  target="_blank" rel="noreferrer">
                        <img className="img-btn-s  " src={aStoreS}  alt="appstore"/>
                    </a>
                </div>
               </div> 
          </div>*/}
      </div>
    )
}

export default TopMenu;